import { render } from "./HomeHeader.vue?vue&type=template&id=28892524&scoped=true&ts=true"
import script from "./HomeHeader.vue?vue&type=script&lang=ts"
export * from "./HomeHeader.vue?vue&type=script&lang=ts"

import "./HomeHeader.vue?vue&type=style&index=0&id=28892524&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28892524"]])

export default __exports__